export default "__VITE_ASSET__CMr$Gm4z__"